import React from "react";

const CheckboxGroupQuestion = ({ question, answers = {}, onChange }) => {
  const selectedAnswers = answers[question.sym_id]?.answer || [];

  const handleToggle = (ans) => {
    const alreadySelected = selectedAnswers.includes(ans.ans_id);
    const updated = alreadySelected
      ? selectedAnswers.filter(id => id !== ans.ans_id)
      : [...selectedAnswers, ans.ans_id];

    onChange(question.sym_id, updated, question);
  };

  // Agrupar por categoria
  const groupedAnswers = question.answers.reduce((acc, ans) => {
    const category = ans.category || "Outros";
    if (!acc[category]) acc[category] = [];
    acc[category].push(ans);
    return acc;
  }, {});

  return (
    <div className="checkbox-group-question">
      {question.label && (
        <div className="chat-message system" dangerouslySetInnerHTML={{ __html: question.label }} />
      )}

      {Object.entries(groupedAnswers).map(([category, options]) => (
        <div key={category} className="checkbox-category mb-4">
          <h5 className="mb-2">{category}</h5>
          <div className="row">
            {options.map((ans) => (
              <div key={ans.ans_id} className="col-md-6 col-lg-4 mb-2">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    checked={selectedAnswers.includes(ans.ans_id)}
                    onChange={() => handleToggle(ans)}
                  />
                  {ans.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CheckboxGroupQuestion;
